<template>
  <CCard
    class="auction-manager-card"
  >
    <CCardHeader>
        <div class="auction-manager-card__header">
          <CInput
            class="auction-manager-card__header-input"
            size="sm"
            placeholder="Search for auction...."
            :value="$route.query.search"
            @input="onInputSearch"
            @keyup.enter="onInputSearch($event.target.value)"
            @keyup.esc="onInputSearch()"
          />
        </div>
    </CCardHeader>
    <CCardBody
      color="white"
      border-color="white"
    >
      <CDataTable
        class="auction-manager__table marketplace-listing-table-container"
        :items="computedItems"
        :fields="fields"
        :loading="loading"
        @row-clicked="toggleRow"
        ref="table"
      >
        <template #rowId={item}>
          <td
            :data-row-id="item.id"
          ></td>
        </template> 

        <template #car="{item}">
          <td>
            <VCarCard
              class="auction-manager__car"
              :car="item.car"
            />
          </td>
        </template>
        <template #link="{item}">
          <td>
            <a
              :class="{ 'auction-manager__disabled-link': !item.link }"
              :href="item.link"
              target="blank"
            >
              Link
            </a>
          </td>
        </template>
        <template #status="{item}">
          <td class="auction-status">
            <CBadge :color="getColor(item.status)">{{item.status}}</CBadge>
          </td>
        </template>
        <template #comments="{item}">
          <td class="comments" :class="item.comments && item.comments.length > 0 ? 'has-comments' : ''">
            <a  @click="openComments(item)" class="cursor-pointer" v-if="item.comments && item.comments.length > 0">View Comments</a>
            <span v-else>No Comment</span>
          </td>
        </template>
        <template #edit-header>
        </template>
        <template #edit={item}>
          <td>
            <CDropdown>
              <template #toggler>
                <CButton class="toggler">
                  <CIcon name="dots" />
                </CButton>
              </template>
              <CDropdownItem
                class="btn btn-info"
                @click="onSoldItem(item)"
              >
                Sold/NA
              </CDropdownItem>
              <CDropdownItem
                class="btn btn-info"
                @click="editItem(item)"
              >
                Edit
              </CDropdownItem>
              <CDropdownItem
                class="btn btn-info"
                @click="onDeleteItem(item)"
              >
                Delete
              </CDropdownItem>
            </CDropdown>
          </td>
        </template>
        
        <template #username="{item}">
          <td class="username">
            <a :href="getUserLink(item.username)" target="_blank">{{item.username}}</a>
          </td>
        </template>
        <template #taxCredit="{item}">
          <td class="verification">
            <select
              class="form-control"
              name="verification-dropdown marketplace"
              v-model="item.taxCredit"
              :id="item.id"
              @change="onTaxCreditChange"
            >
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </td>
        </template>
        <template #verifiedBy="{item}">
          <td class="auction-verified">
            {{item.verifiedBy}}
          </td>
        </template>
      
        <template #featured="{item}">
          <td class="featured-status">
            <!-- <input type="checkbox"
            class=""
              size="lg"
              custom
              :name="item.id"
              :id="item.id"
              :checked="item.featured === 1 ? true : false"
              :disabled="item.status === 'In Progress' ? false: true"
              @change="onChangeCheckBoxInput"
            /> -->
            <CInputCheckbox
            class=""
              size="lg"
              custom
              :name="item.id"
              :id="item.id"
              :checked="item.featured === 1 ? true : false"
              :disabled="item.status === 'In Progress' ? false: true"
              @change="onChangeCheckBoxInput"
            />
          </td>
        </template>
        <template #isTestMode="{item}">
          <td class="featured-status">
            <!-- <input type="checkbox"
            class=""
            size="lg"
              custom
              :name="item.id"
              :id="item.id"
              :checked="item.isTestMode === 1 ? true : false"
              @change="onChangeTestCheckBoxInput"
            /> -->
            <CInputCheckbox
            class=""
              size="lg"
              custom
              :name="item.id"
              :id="item.id"
              :checked="item.isTestMode === 1 ? true : false"
              @change="onChangeTestCheckBoxInput"
            />
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CCardFooter class="auction-manager-card__footer">
      <VAuctionManagerPagination
        class="auction-manager-card__footer-pagination"
        :current-page.sync="currentPage"
      />
    </CCardFooter>
  </CCard>
</template>
<script>
import { auctionManagerStore, createAuctionManagerMixin } from '@/mixins/auctionsManagerMixin'
import VAuctionManagerPagination from '@/components/AuctionManager/VAuctionManagerPagination'
import VCarCard from '@/components/AuctionManager/VCarCard'
import { toggleRowClass } from '@/utils/table/toggleRowClass'
import { debounce } from '@/utils/debounce'
import ModalType from '@/utils/dictionaries/modalType'
import { getLastCarBid, getStatus, getStatusColor, isReversePriceNotMeet, isZeroBids, isEndedCar } from '@/utils/validation/car'
import { CAR_STATUS } from '@/utils/dictionaries/car'
import getTimerFromNowToDate from '@/utils/time/getTimerFromNowToDate'
import { getUserLink } from '@/utils/validation/user'
import URLS from '@/constants/url'
import { CInputCheckbox } from '@coreui/vue'
import api from "@/api/api";
import moment from 'moment'

import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";
import { encodeToBase62 } from '@/utils/slug'
const defaultImage = 'https://media.carsandbids.com/cdn-cgi/image/width=712,height=468,quality=70/da4b9237bacccdf19c0760cab7aec4a8359010b0/photos/3ja0R3IXGI2-2.lmFYrFQis.jpg?t=160323755351'

export default {
  name: 'MarketplaceListing',

  components: {
    VCarCard,
    VAuctionManagerPagination,
    CInputCheckbox
},

  mixins: [
    createAuctionManagerMixin(),
    createCarManagerMixin()
  ],

  data () {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'createdAt', label: 'Date Added', _classes: 'username', _style: 'min-width: 200px;max-width: 200px' },
        { key: 'username', label: 'Vehicle Details', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'reserveValue', label: 'Price', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        {
          key: "comments",
          label: "View Comments",
        },
        {
          key: "payOffAmount",
          label: "Payoff Amount",
          _classes: "comments"
        },
        {
          key: "payOffBank",
          label: "Payoff Bank",
          _classes: "comments"
        },
        { key: 'link', label: 'Link', _style: 'min-width: 62px;max-width: 62px' },
        {
          key: "taxCredit",
          label: "Tax Credit",
          _classes: "auction-bid",
          _style: "min-width: 120px;max-width: 300px"
        },        { key: 'vin', label: 'VIN', _style: 'min-width: 100px;max-width: 100px' },
        { key: 'edit', label: 'Edit', _style: 'min-width: 125px;max-width: 62px' },
      ],
      checkedRows: [],
      currentPage: 1,
      loading: false,
      searchFn: () => {},
      getUserLink: getUserLink
    }
  },

  async created () {
    await this.loadData()

    this.searchFn = debounce.call(this, async (term) => {
      const query = {
        ...this.$route.query,
        search: term
      }

      if (!query.search && query.skip) {
        query.skip = 0
      }

      this.$router.push({
        query
      }).catch(() => {})
    }, 200)
  },

  watch: {
    isReload(newValue){
      this.loadData();
    },
    checkedRows (rows) {
      this.checkRows(rows, 'auction-manager__row-checked')
    },
    computedItems() {
      this.checkRestartRows()
    },
    $route () {
      this.clearCheckboxes()
      this.loadData()
    }
  },

  computed: {
    isReload() {
      return this[auctionManagerStore.getterTypes.GETTER_PAGE_RELOAD];
    },
    auctions () {
      return this[auctionManagerStore.getterTypes.GETTER_AUCTIONS]
    },
    auctionsCount () {
      return this[auctionManagerStore.getterTypes.GETTER_AUCTIONS_COUNT]
    },
    
    computedItems () {
      return this.auctions && this.auctions.map(a => {
        const item  = {
          id: a.id,
          username: a.owner.username,
          car: {
            title: a.title,
            make: a.make,
            model: a.model,
            year: (a.title && a.title.split(' ')[0]) || '',
            imageUrl: this.findImage(a.carImages),
            link: this.getLink(a),
            uuid: a.uuid,
            year: a.year,
            make: a.make,
            model: a.model,
          },
          payOffAmount: a.payOffAmount || "",
          payOffBank: a.payOffBank || "",
          verifiedBy: (a.verifiedBy && a.verifiedBy.username) || '',
          status: this.getStatus(a),
          auctionKind: a.reserve ? 'reserve' : 'no reserve',
          lastBid: this.getLastBid(a),
          link: this.getLink(a),
          startDate: a.startDate,
          endDate: a.endDate,
          featured: a.featured,
          comments: a.comments,
          isTestMode: a.isTestMode,
          vin: a.vin,
          reserveValue: "$"+a.reserveValue,
          createdAt: moment(a.createdAt).format("lll"),
          taxCredit: a.taxCredit
        }
        // this.checkCarTimer(item) TODO: Make status value from awaiting to In progress
        return item
      })
    },
    checkedRowsCount () {
      return this.checkedRows.length
    },
    isChecked () {
      return this.checkedRows
        .map(row => row.id)
        .reduce((acc, val) => {
          acc[val] = true
          return acc
        }, {})
    }
  },

  methods: {
    async onTaxCreditChange(event){
      // try {
      //   this.loading = true
      //   const formData = new FormData()
      //   formData.append("taxCredit",event.target.value)
      //   await this[marketplaceStore.actionTypes.ACTION_UPDATE_MARKETPLACE_CAR]({ carId: event.target.id, formData: formData})
      //   this.loadData()
      // } catch (error) {
      //   console.log("error in change type", error)      
      // }
      console.log("onTaxCreditChange value", event.target.value)
      console.log("onTaxCreditChange id", event.target.id)
    },
    onSoldItem(item) {
      const soldAction = async () => {
        try {
          await api.put(`/statistical/car-sold/${item.id}`);
          this.$modals.close(ModalType.ConfirmationModal);
          this.$router.go();
        } catch (error) {
          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Sold",
        body: `Are you sure this car has been sold?`,
        buttonText: "Sold",
        onClickButton: soldAction
      });
    },
    onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          await api.delete(`/cars/${item.id}`);
          this.$modals.close(ModalType.ConfirmationModal);
          this.$router.go();
        } catch (error) {
          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: `Are you sure you want to delete this car?`,
        buttonText: "Delete",
        onClickButton: deleteAction
      });
    },
    openComments(item){
      const { comments, ...itemWithoutComments } = item;
        return this.$modals.open(ModalType.CommentsModal, {
          ...itemWithoutComments,
          disabled: false
        });    
    },
    findImage(carImages){
        if(carImages.length > 0){
          let url = ""
          url = carImages.find(c => c.mainImage === 1 )?.url;
          if(!url){
            url = carImages.find(c => c.illustratorId === 1 )?.url;
          }
          if(!url){
            url = defaultImage
          }
          return url
        }
        return 
      },
    editItem (item) {
      console.log("edit item")
      const auction = this.auctions.find(a => a.id === item.id)
      const disabled = isEndedCar(auction) && !this.canRestart(auction)
      this.$modals.open(ModalType.EditAuctionModal, { ...auction, disabled: disabled})
    },
    clearCheckboxes () {
      this.checkedRows = []
      this.canRestartRows = []
    },
    checkRestartRows() {
      const canRestartRows = this.auctions.filter(a => this.canRestart(a))
      this.checkRows(canRestartRows, 'auction-manager__row-restart')
    },
    getStatus (auction) {
      return getStatus(auction)
    },
    getColor (status) {
      return getStatusColor(status)
    },
    getLastBid (auction) {
      return getLastCarBid(auction)
    },
    getLink (auction) {
      const status = this.getStatus(auction)
      if (status !== CAR_STATUS.Ended && status !== CAR_STATUS.Progress) {
        return ''
      }
      return `${URLS.app}/t3-marketplace/${auction.year
              .trim()
              .replaceAll(" ", "-")}-${auction.make
              .trim()
              .replaceAll(" ", "-")}-${auction.model
              .trim()
              .replaceAll(" ", "-")}/${encodeToBase62(auction.uuid)}`
    },
    toggleAll () {
      if (this.checkedRows.length) {
        this.checkedRows = []
      } else {
        this.checkedRows = [...this.computedItems]
      }
    },
    toggleRow(item, index, columName, event) {
      console.log("toggleRow")
      if (this.checkedRows && this.checkedRows.includes(item) && event.path && event.path.some(el => el?.classList?.contains('toggler'))) return

      if (this.isChecked[item.id]) {
        this.checkedRows = []
      } else {
        this.checkedRows = [item]
      }
    },
    checkCarTimer(item) {
      const changeStatus = (time, timerId, status, restartCheck = false) => {
        if (time >= 0) {
          clearTimeout(timerId)
          item.status = status
          if (restartCheck) {
            this.checkCarTimer(item)
          }
        }
      }
      if (item.status === CAR_STATUS.Awaiting) {
        getTimerFromNowToDate(item.startDate, (time, timerId) => 
          changeStatus(time, timerId, CAR_STATUS.Progress, true))
      } else {
        getTimerFromNowToDate(item.endDate, (time, timerId) => 
          changeStatus(time, timerId, CAR_STATUS.Ended))
      }
    },
    async loadData () {
      this.loading = true
      await this[auctionManagerStore.actionTypes.ACTION_LOAD_MARKETPLACE_AUCTIONS]({
        take: this.$route.query.take || 10,
        skip: this.$route.query.skip || 0,
        search: this.$route.query.search,
        all: true
      })
      this.loading = false

      this.checkRestartRows()
    },
    onInputSearch (value) {
      this.searchFn(value)
    },
    canRestart(auction) {
      return isEndedCar(auction) && (isReversePriceNotMeet(auction) || isZeroBids(auction))
    },
    checkRows(rows, rowClass) {
      if (!this.$refs.table) return
      const rowsSelector = rows.reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, '').replace(/,$/, '')
      const rowsEl = rowsSelector.length > 0 ? this.$refs.table.$el.querySelectorAll(rowsSelector) : []

      const allRowsSelector = this.computedItems.reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, '').replace(/,$/, '')
      const allRowsEl = allRowsSelector.length > 0 ? this.$refs.table.$el.querySelectorAll(allRowsSelector) : []

      Array.from(allRowsEl).forEach(row => {
        if (row.parentNode.nodeName === 'TR') {
          toggleRowClass(row.parentNode, rowClass, false)
        }
      })

      Array.from(rowsEl).forEach(row => {
        if (row.parentNode.nodeName === 'TR') {
          toggleRowClass(row.parentNode, rowClass)
        }
      })

    },
    onChangeCheckBoxInput($event){
      console.log("onChangeCheckBoxInput", $event.target.id)
      this[auctionManagerStore.actionTypes.ACTION_CAR_FEATURED]({ id: Number($event.target.id), featured: $event.target.checked, route: this.$route })
      // alert("test", $event?.target?.checked)
    },
    onChangeTestCheckBoxInput($event){
      console.log("onChangeCheckBoxInput", $event.target.id)
      this[carManagerStore.actionTypes.ACTION_TEST_MODE_CAR]({ id:  Number($event.target.id), isTestMode:  $event.target.checked })
      // alert("test", $event?.target?.checked)
    }
  }
}
</script>
